<template>
  <div>
    <div v-if="pageName !== 'bets'" class="my-bet-section">
      <v-expansion-panels
        :value="openAll(betsDatas, pageName === 'bets')"
        flat
        tile
        light
        multiple
      >
        <v-expansion-panel
          v-for="(betsData, i) in betsDatas"
          :key="'betdata' + i"
          class="mt-1 mb-5 p-0"
        >
          <v-expansion-panel-header
            class="pl-0 pt-0 pb-0 caption align-self-stretch"
          >
            <v-row no-gutters>
              <v-col
                cols="6"
                class="white--text pl-2 py-2"
                style="min-height: 40px"
              >
                {{ betsData.name }}
              </v-col>
              <v-col cols="5">
                <div
                  v-if="
                    !checkunMatchBets() && betsData.name === 'Unmatched Bets'
                  "
                  class="d-flex align-end flex-column pr-1 py-1"
                >
                  <v-btn
                    small
                    color="red darken-3"
                    tile
                    dark
                    depressed
                    @click.native.stop="cancelBet()"
                    >Cancel All</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content dark class="black--text pa-0">
            <div
              v-if="betsData.name === 'Unmatched Bets'"
              :class="checkunMatchBetsClass()"
            >
              <div
                v-for="(unMatchedbets, j) in betsData.unMatchedbets"
                :key="'unmatchBets' + j"
              >
                <v-list-item-title class="caption font-weight-bold px-2 pt-2">
                  {{ unMatchedbets.name }}
                </v-list-item-title>
                <div
                  v-for="(market, u) in unMatchedbets.markets"
                  :key="'market' + j + u"
                >
                  <v-card
                    v-for="(betsData1, betIndex) in market.selections"
                    :key="'unmatchBets' + betIndex"
                    class="pa-0 mb-0 caption mybet-card"
                    light
                  >
                    <div class="unmatch-section">
                      <div>
                        <v-list-item-title
                          class="caption font-weight-bold px-2"
                        >
                          <div
                            v-if="!checkunMatchBets()"
                            class="d-flex mt-2 pt-1 pr-1"
                          >
                            <v-row no-gutters>
                              <v-col cols="6"> {{ market.name }} </v-col>
                              <v-col cols="6">
                                <v-btn
                                  v-if="
                                    betsData1 &&
                                    betsData1.bets &&
                                    betsData1.bets[0].betType !== 'threeEt'
                                  "
                                  x-small
                                  color="red darken-3"
                                  tile
                                  text
                                  class="flex-column float-right align-end"
                                  @click.native.stop="cancelPerMatch(betsData1)"
                                >
                                  Cancel
                                </v-btn>
                              </v-col>
                            </v-row>
                          </div>
                        </v-list-item-title>
                        <div>
                          <!-- <div
                          v-for="(bets, betsIndex) in betsData1"
                          :key="'bets' + betsIndex"
                        > -->
                          <div
                            v-for="(bet, betIndex1) in betsData1"
                            :key="'bet' + betIndex1"
                            :class="{
                              secondary: bet.side == 'Back',
                              accent: bet.side == 'Lay'
                            }"
                            class="px-2 pt-3"
                          >
                            <v-list-item-title class="caption px-2 pt-1">
                              {{ bet.selectionName }}
                            </v-list-item-title>
                            <v-row align="center" justify="center" class="my-0">
                              <v-col cols="3" class="pb-0">
                                <v-text-field
                                  ref="odds"
                                  :value="bet.price"
                                  label="Odds"
                                  persistent-hint
                                  outlined
                                  dense
                                  readonly
                                  class="caption font-weight-bold"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="3" class="pb-0">
                                <v-text-field
                                  ref="stake"
                                  :value="bet.stake"
                                  label="Stake"
                                  persistent-hint
                                  outlined
                                  dense
                                  readonly
                                  class="caption font-weight-bold"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="3" class="pt-0 pb-0">
                                <div
                                  style="font-size: 10px; margin-top: -22px"
                                  class="font-weight-bold"
                                >
                                  Profit
                                </div>
                                <div class="font-weight-bold">
                                  {{
                                    ((bet.price - 1) * bet.stake)
                                      | currencyFormat(2)
                                  }}
                                </div>
                              </v-col>
                              <v-col cols="3" class="pt-0 pb-0">
                                <v-tooltip top>
                                  <template #activator="{ on }">
                                    <v-btn
                                      v-if="bet.betType !== 'threeEt'"
                                      color="red darken-3"
                                      block
                                      small
                                      dark
                                      :loading="loading"
                                      depressed
                                      v-on="on"
                                      @click="cancelBet(bet, '')"
                                    >
                                      <v-icon size="14">mdi-close</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Cancel</span>
                                </v-tooltip>
                              </v-col>
                            </v-row>
                            <v-divider></v-divider>
                          </div>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                  </v-card>
                </div>
              </div>
              <div v-if="!betsData.unMatchedbets.length && !loading">
                <no-data-found
                  icon-custom="mdi mdi-alert"
                  bet-text="No Unmatched Bets!"
                />
              </div>
            </div>

            <div v-if="betsData.name === 'Matched Bets'">
              <div class="green--text">
                <v-checkbox
                  v-if="betsData.matchedBets.length"
                  v-model="showAverage"
                  label="Average Odds"
                  hide-details
                  class="my-0 caption top-0 ml-2"
                  dense
                ></v-checkbox>
              </div>
              <div v-if="showAverage">
                <average-bets :bets="betsData.matchedBets"></average-bets>
              </div>
              <div v-if="!showAverage">
                <template
                  v-for="(bet, j) in betsData.matchedBets.filter(
                    (item) => item.eventId === $route.params.id
                  )"
                >
                  <ob-card
                    :key="'ob-card-' + j"
                    :bets-data="betsData"
                    :bets-group="bet"
                  ></ob-card>
                  <v-divider :key="'divider-' + j"></v-divider>
                </template>
              </div>
              <div
                v-if="
                  !betsData.matchedBets.filter(
                    (item) => item.eventId === $route.params.id
                  ).length
                "
              >
                <no-data-found
                  bet-text="No Matched Bets!"
                  icon-custom="mdi mdi-alert"
                />
              </div>
            </div>

            <v-divider></v-divider>
            <div v-if="betsData.name === 'Premium SportsBook Transaction'">
              <div v-if="!matchedBetPremiumData.length">
                <no-data-found
                  icon-custom="mdi mdi-alert"
                  bet-text="No Premium SportsBook Transaction Bets!"
                />
              </div>
              <matched-bets-premium
                v-if="matchedBetPremiumData.length"
                :bet-data-matched-premium="matchedBetPremiumData"
              />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <!-- ****** only for open bet drawer show this section ******-->
    <div v-if="pageName === 'bets'" class="bet-market-section">
      <v-tabs v-model="tabs" centered>
        <v-tab class="caption" @click="opendata()"> my bet </v-tab>
        <v-tab class="caption" @click="opneMyMarket()"> my market </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tabs">
        <!-- my bets section -->
        <v-tab-item>
          <v-expansion-panels
            :value="openAll(betsDatas, pageName === 'bets')"
            flat
            tile
            light
            multiple
          >
            <v-expansion-panel
              v-for="(betsData, i) in betsDatas"
              :key="'betdatas' + i"
              class="mt-2"
            >
              <v-expansion-panel-header class="caption grey lighten-2">
                {{ betsData.name }}
              </v-expansion-panel-header>
              <v-expansion-panel-content color="white" class="black--text pa-0">
                <div v-if="betsData.name === 'Unmatched Bets'">
                  <div>
                    <v-card
                      v-for="(unMatchedbets, j) in betsData.unMatchedbets"
                      :key="'unmatchBets' + j"
                      class="pa-0 caption mybet-card"
                      light
                    >
                      <div class="caption px-2">
                        {{ unMatchedbets.name }}
                      </div>
                      <div
                        v-for="(
                          betsDataMarket, betIndexs
                        ) in unMatchedbets.markets"
                        :key="'unmatchBets' + betIndexs"
                      >
                        <div class="caption font-weight-bold px-2">
                          {{ betsDataMarket.name }}
                        </div>
                        <div
                          v-for="(
                            selections, betIndex
                          ) in betsDataMarket.selections"
                          :key="'unmatchBets' + betIndex"
                        >
                          <div
                            v-for="(bet, betsIndex) in selections"
                            :key="'bet' + betsIndex"
                          >
                            <!-- <div class="caption pt-1 px-2">
                            {{ bet.horse }}
                          </div> -->
                            <div
                              :class="{
                                secondary: bet.side == 'Back',
                                accent: bet.side == 'Lay'
                              }"
                              class="pa-2"
                            >
                              <div class="unmatch-section pa-2">
                                <nuxt-link
                                  :to="`/sportsbook/${bet.eventTypeId}/${bet.competitionId}/${bet.marketId}`"
                                >
                                  <div class="font-weight-bold">
                                    <span v-if="bet.betType === 'fancy'">{{
                                      bet.side == 'Back' ? 'YES' : 'NO'
                                    }}</span>
                                    <span v-if="bet.betType !== 'fancy'">
                                      {{ bet.side }}</span
                                    >
                                    {{
                                      bet.side == 'Back'
                                        ? 'BACK' + ' '
                                        : 'LAY' + ' '
                                    }}
                                    {{ bet.selectionName }} for
                                    {{ bet.stake | currencyFormat(0) }} @
                                    <span v-if="bet.betType !== 'fancy'">
                                      {{
                                        (bet.betType !== 'matchOdds' &&
                                        bet.placeBetCalcType === 1
                                          ? (bet.averagePrice - 1) * 100
                                          : bet.betType !== 'matchOdds' &&
                                            bet.placeBetCalcType === 2
                                          ? bet.averagePrice - 1
                                          : bet.averagePrice)
                                          | currencyFormat(3)
                                          | fancyOdds(
                                            bet.marketName,
                                            bet.eventType,
                                            bet.marketId,
                                            bet.placeBetCalcType,
                                            bet.betType
                                          )
                                      }}
                                    </span>
                                    <span v-if="bet.betType === 'fancy'">
                                      {{
                                        ((bet.averagePrice - 1) * 100)
                                          | currencyFormat
                                      }}
                                    </span>

                                    {{
                                      bet.side == 'Back'
                                        ? 'to win'
                                        : 'liability'
                                    }}
                                    {{
                                      ((bet.price - 1) * bet.stake)
                                        | currencyFormat(2)
                                    }}.
                                  </div>

                                  <div>
                                    <span>{{ betsDataMarket.name }}</span>
                                  </div>
                                  <!-- <div>
                                    <span>{{ bet.marketName }}</span>
                                  </div> -->

                                  <div>
                                    <span>Placed</span>

                                    {{
                                      $moment(bet.betPlacedDate).format(
                                        'DD/MM/YYYY, h:mm:ss a'
                                      )
                                    }}
                                  </div>
                                </nuxt-link>
                                <div class="my-2">
                                  <v-btn
                                    color="primary"
                                    tile
                                    small
                                    dark
                                    @click="cancelBet(bet, '')"
                                    >Cancel</v-btn
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </div>
                  <div v-if="!betsData.unMatchedbets.length && !loading">
                    <no-data-found
                      icon-custom="mdi mdi-alert"
                      bet-text="No Unmatched Bets!"
                    />
                  </div>
                </div>
                <div v-if="betsData.name === 'Matched Bets'">
                  <div v-if="!betsData.matchedBets.length && !loading">
                    <no-data-found
                      icon-custom="mdi mdi-alert"
                      bet-text="No Matched Bets!"
                    />
                  </div>
                  <matched-bets :bet-data-matched="betsData.matchedBets" />
                </div>

                <div v-if="betsData.name === 'Premium SportsBook Transaction'">
                  <div v-if="!matchedBetPremiumData.length">
                    <no-data-found
                      icon-custom="mdi mdi-alert"
                      bet-text="No Premium SportsBook Transaction Bets!"
                    />
                  </div>
                  <matched-bets-premium
                    :bet-data-matched-premium="matchedBetPremiumData"
                  />
                </div>
                <v-divider></v-divider>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-tab-item>
        <!-- my market section -->
        <v-tab-item>
          <v-container class="pt-2 px-0">
            <v-skeleton-loader
              v-if="loading"
              tile
              light
              dense
              type="list-item-two-line, list-item-two-line"
            >
            </v-skeleton-loader>

            <div v-if="isEmpty === true" class="pa-5">
              <no-data-found
                icon-custom="mdi mdi-alert"
                bet-text="Your markets will be shown here."
              />
              <!-- <v-alert dense border="left" outlined type="warning">
                Your markets will be shown here.
              </v-alert> -->
            </div>
            <div v-if="isEmpty === false">
              <my-market-data
                v-if="betsDatas[1].matchedBets.length"
                :my-market-data="betsDatas[1].matchedBets"
              />
            </div>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
// import NoResult from '@/components/NoResult'
// import FavoriteBtn from '@/components/FavoriteBtn'
import MatchedBets from '@/components/MatchedBets'
import NoDataFound from '@/components/NoDataFound'
import ObCard from '@/components/open-bets/ObCard'
import AverageBets from '@/components/open-bets/AverageBets'
import MyMarketData from '@/components/MyMarketData'
import MatchedBetsPremium from '@/components/MatchedBetsPremium'
// import socket from '@/plugins/socket.client'

export default {
  components: {
    NoDataFound,
    MatchedBets,
    MyMarketData,
    MatchedBetsPremium,
    ObCard,
    AverageBets
  },
  data() {
    return {
      showAverage: false,
      menu: false,
      tabs: null,
      pageName: this.$route.name,
      panel: [],
      eventIdForBets: false,
      marketsEmpty: true
    }
  },

  computed: {
    ...mapState({
      // open bets variables
      hideMatch: (state) => state.openBets.hideMatch,
      hideUnMatch: (state) => state.openBets.hideUnMatch,
      deleteData: (state) => state.openBets.deleteData,
      loading: (state) => state.openBets.loading,
      betsDatas: (state) => state.openBets.betsDatas,
      unmatched: (state) => state.openBets.unmatched,
      unMatchedbetsLength: (state) => state.openBets.unMatchedbetsLength,
      cancelLoading: (state) => state.openBets.cancelLoading,
      cancelflag: (state) => state.openBets.cancelflag,
      matchedBetPremiumData: (state) => state.openBets.matchedBetPremium,

      // my market variables
      isEmpty: (state) => state.openBets.marketsEmpty
    })
  },

  async mounted() {
    if (!this.$route.params.id) {
      this.$store.commit('openBets/empty_data')
    }
    await this.initiate(true)
    // socket.on('BetExecuted_' + this.$auth.user._id, async (data) => {
    //   this.betsDatas[0].unMatchedbets.map((bet) => {
    //     if (bet.betId === data._id) {
    //       bet.remove = true
    //     }
    //     return bet
    //   })
    //   if (data.is3ET) {
    //     this.$store.commit('snackbar/open', {
    //       text: 'Bet Placed successfully!',
    //       color: 'success'
    //     })
    //   }
    //   await this.initiate(false)
    // })

    // socket.on('AllSocket_' + this.$auth.user._id, async (eventKeys) => {
    //   if (eventKeys.eventKey === 'BetExecuted_' + this.$auth.user._id) {
    //     this.betsDatas[0].unMatchedbets.map((bet) => {
    //       if (bet.betId === eventKeys._id) {
    //         bet.remove = true
    //       }
    //       return bet
    //     })
    //     if (eventKeys.is3ET) {
    //       this.$store.commit('snackbar/open', {
    //         text: 'Bet Placed successfully!',
    //         color: 'success'
    //       })
    //     }
    //     await this.initiate(false)
    //   }
    // })
    // socket.on('BetCancelled_' + this.$auth.user._id, async (data) => {
    //   // console.log('BetCancelled_.........', data)
    //   this.$store.commit('snackbar/open', {
    //     text: data.message,
    //     color: 'error'
    //   })

    //   await this.initiate(false)
    // })
    // socket.on('Bet3et_' + this.$auth.user._id, async (data) => {
    //   this.$store.commit('snackbar/open', {
    //     text: data.message,
    //     color: 'success'
    //   })

    //   await this.initiate(false)
    // })
  },

  beforeDestroy() {
    // socket.off('BetExecuted_' + this.$auth.user._id)
    // socket.off('BetCancelled_' + this.$auth.user._id)
    // socket.off('Bet3et_' + this.$auth.user._id)
    if (!this.$route.params.id) {
      this.$store.commit('openBets/empty_data')
    }
  },
  methods: {
    opendata() {},
    // closeAllPanels() {
    //   this.openedPanel = []
    // },
    // openPanel(bets) {
    //   this.openedPanel.push(bets)
    // },
    opneMyMarket() {
      this.$store.dispatch('myMarkets/getMarkets')
    },
    async initiate(bool) {
      await this.$store.dispatch('openBets/getMyCurrentBetStatus', bool)
    },
    checkunMatchBets() {
      // eslint-disable-next-line array-callback-return
      const output = this.betsDatas.filter((b) => {
        if (b.unMatchedbets && b.unMatchedbets.length) {
          return b
        }
      })
      return !output.length
    },

    checkunMatchBetsClass() {
      if (
        this.betsDatas[0].unMatchedbets.length &&
        this.betsDatas[1].matchedBets.length
      ) {
        return {
          'overflow-minor-scroll': true,
          'overflow-scroll': false
        }
      } else if (this.betsDatas[0].unMatchedbets.length) {
        return {
          'overflow-minor-scroll': false,
          'overflow-scroll': true
        }
      } else {
        return {
          'overflow-minor-scroll': false,
          'overflow-scroll': false
        }
      }
    },
    checkMatchBetsClass() {
      if (
        this.betsDatas[0].unMatchedbets.length &&
        this.betsDatas[1].matchedBets.length
      ) {
        return {
          'overflow-minor-scroll': true,
          'overflow-scroll': false
        }
      } else if (this.betsDatas[1].matchedBets.length) {
        return {
          'overflow-minor-scroll': false,
          'overflow-scroll': true
        }
      } else {
        return {
          'overflow-minor-scroll': false,
          'overflow-scroll': false
        }
      }
    },
    openAll(v, betsPage = false) {
      const betsCount = [
        this.unMatchedbetsLength,
        betsPage
          ? this.betsDatas[1].matchedBets.length
          : this.betsDatas[1].matchedBets.filter(
              (item) => item.eventId === this.$route.params.id
            ).length,
        this.matchedBetPremiumData.length
      ]
      // eslint-disable-next-line array-callback-return
      const panelOpen = betsCount.map((d, i) => {
        if (d > 0) {
          return i
        }
      })
      return [...panelOpen]
    },
    cancelPerMatch(unmatchedBetData) {
      const betArray = []
      if (unmatchedBetData.bets.length) {
        for (const bet of unmatchedBetData.bets) {
          const obj = {}
          obj.betId = bet.betId
          betArray.push(obj)
          // this.cancelBet(bet, '', 'All Bets Cancelled')
        }
        this.cancelMultipleBets(betArray)
      }
    },

    cancelAllBets() {
      const allunmatchedBets = []
      if (this.unmatched.length) {
        this.unmatched.forEach((bets) => {
          bets.markets.forEach((market) => {
            market.runners.forEach((runners) => {
              allunmatchedBets.push(...runners.bets)
            })
          })
        })

        const betArray = []
        for (const bet of allunmatchedBets) {
          if (bet.betType !== 'threeEt') {
            const obj = {}
            obj.betId = bet.betId
            betArray.push(obj)
          } else {
            this.$store.commit('snackbar/open', {
              text: 'Cant cancel the premium bet, bet is in process',
              color: 'error'
            })
          }
        }
        if (betArray.length > 0) {
          this.cancelMultipleBets(betArray)
        }
      }
    },
    async cancelMultipleBets(betArray) {
      const accessTokenId = this.$auth.getToken('customLocal')
      const payloadData = {
        accessToken: accessTokenId,
        betArray
      }
      await this.$store.dispatch(
        'openBets/cancelPlayerBetPerMatch',
        payloadData
      )
      const betMsgs = []
      if (this.deleteData.value) {
        for (const bet of this.deleteData.data) {
          betMsgs.push(bet.message)
        }
        this.$store.commit('snackbar/openMultiple', {
          texts: betMsgs,
          color: this.deleteData.data[0].value ? 'success' : 'error'
        })
      } else if (this.deleteData.error === 'accessDenied') {
        this.$store.commit('snackbar/open', {
          text: 'Access Denied',
          color: 'error'
        })
      } else {
        this.$store.commit('snackbar/open', {
          text: 'Error while cancelling Bet',
          color: 'error'
        })
      }
    },
    async cancelBet(betArray, level, successText = 'Bet Cancelled') {
      // const betidData = betArray.betId
      // const betTypeData = betArray.betType
      // const reqData = []
      // const accessTokenId = this.$auth.getToken('customLocal')
      // reqData.push({
      // betId: betidData,
      // betType: betTypeData
      // })

      const payloadData = {
        // accessToken: accessTokenId,
        betId: betArray?.apolloBetId
        // betType: betTypeData
      }
      await this.$store.dispatch('openBets/cancelPlayerBet', payloadData)

      if (this.deleteData.result) {
        for (const bet of this.deleteData.result.result.cancelled) {
          this.$store.commit('snackbar/open', {
            text: bet.status,
            color: bet.status ? 'success' : 'error'
          })
        }
      } else if (this.deleteData.error === 'accessDenied') {
        this.$store.commit('snackbar/open', {
          text: 'Access Denied',
          color: 'error'
        })
      } else {
        // console.log('set_delete_data 333')
        this.$store.commit('snackbar/open', {
          text: 'Error while cancelling Bet',
          color: 'error'
        })
      }

      // if (this.deleteData.message) {
      //   this.$store.commit('snackbar/open', {
      //     text: this.deleteData.message,
      //     color: this.deleteData.message ? 'success' : 'error'
      //   })
      // } else if (!this.deleteData.message && this.deleteData.value) {
      //   this.$store.commit('snackbar/open', {
      //     text: successText,
      //     color: 'success'
      //   })
      // } else if (this.deleteData.error === 'accessDenied') {
      //   this.$store.commit('snackbar/open', {
      //     text: 'Access Denied',
      //     color: 'error'
      //   })
      // } else {
      //   this.$store.commit('snackbar/open', {
      //     text: 'Error while cancelling Bet',
      //     color: 'error'
      //   })
      // }

      await this.$store.dispatch('openBets/getMyCurrentBetStatus', false)
      // this.betsDatas[0].unmatchBets = this.unmatchBets
      // this.betsDatas[1].matchBets = this.matchBets
    }
  }
}
</script>
<style lang="scss" scopped>
.mybet-card {
  border-radius: 0px !important;
  box-shadow: none !important;
  .unmatch-section {
    a {
      color: rgba(0, 0, 0, 0.87);
      text-decoration: none !important;
    }
    // .secondary {
    .caption {
      .v-input__control {
        .v-input__slot {
          background-color: white;
        }
      }
    }
    // }
  }
  &.caption.v-card.v-card--link.opacityLess {
    opacity: 0.6;
  }
}
.top-0.caption .v-label {
  top: 0px !important;
}
.my-bet-section {
  background: #121212;
  .caption .v-label {
    font-weight: bold;
    color: #000000;
    top: 3px !important;
    font-size: 0.8rem;
  }
}
.theme--light.v-expansion-panels .v-expansion-panel {
  background-color: #121212;
  color: rgba(0, 0, 0, 0.87);
  border: 1px solid #f36c21;
  border-radius: 12px;
}
.mybet-card .v-expansion-panel-header__icon i.v-icon {
  background: #f36c21;
  border-radius: 100%;
  font-size: 1.2rem;
}
.mdi-chevron-down::before {
  background: #f36c21;
  border-radius: 50%;
  color: #fff;
}
</style>
